<script>
	export let headline = "";
	export let text = "";
	export let color = "#FFFDD7";
</script>

<div class="content" style="--highlight-color: {color}">
	{#if headline || text}
		{#if headline}
			<div class="headline">{@html headline}</div>
		{/if}
		{#if text}
			<div class="text">{@html text}</div>
		{/if}
	{/if}
</div>

<style lang="scss">
	.content {
		margin: 0 auto;
		width: 100%;
		position: absolute;
		bottom: 0;
		box-sizing: border-box;
		letter-spacing: 0.01em;
		max-width: 450px;
		border-radius: 4px;
		background: rgba(92, 84, 153, 0.15);
		box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
		backdrop-filter: blur(10px);
		font-family: Abril Text;


		.headline {
			font-weight: $bold;
			margin-bottom: 5px;
			color: #f3f3f3;
		}

		.text {
			color: #f3f3f3;
			font-size: 18px;
			font-style: normal;
			font-weight: 400;
			line-height: 28px;

			& > :global(strong) {
				color: var(--highlight-color);
				border-radius: 3px;
				background: linear-gradient(180deg, rgba(var(--highlight-color), 0.3) 0%, rgba(var(--highlight-color), 0) 100%);
			}

			& > :global(a) {
				color: white !important;
			}
		}
	}

	@media (min-width: #{$breakpoint-mobile-l + 1px}) {
		.content {
			padding: 25px 30px;
			font-size: 20px;
			line-height: 28px;
		}
	}

	@media (max-width: $breakpoint-mobile-l) {
		.content {
			padding: 15px;
			
			margin: 0;
			box-sizing: border-box;
			background: rgba(78, 74, 111, 0.8);

			.text {
				font-size: 16px;
				line-height: 24px;
			}
		}
	}
</style>
